// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .virtual-table-wrapper {
    border: 1px solid var(--table-border-color);
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    overflow: hidden;
  }
  
  .table-header {
    display: flex;
    background-color: var(--table-header-bg-color, #f0f0f0);
    border-bottom: 1px solid var(--table-border-color);
  }
  
  .virtual-table-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
  }
  
  .table-header {
    flex-shrink: 0;
    height: 40px;
  }
  
  .table-row {
    display: flex;
    border-bottom: 1px solid var(--table-border-color);
  }
  
  .table-cell {
    flex: 1;
    padding: 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border-right: 1px solid #eee;
  }
  
  .table-cell:last-child {
    border-right: none;
  }
  
  .header-cell {
    font-weight: bold;
    background: var(--table-header-bg-color, #eaeaea);
  }
  
  .even {
    background: #ffffff;
  }
  
  .odd {
    background: #f9f9f9;
  }
   */

   .virtual-table-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    border: 1px solid var(--table-border-color);
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    background-color: var(--table-background-color);
  }
  
  /* Table Header */
  .table-header {
    display: flex;
    flex-shrink: 0;
    height: 40px;
    background-color: var(--table-header-bg-color, #f0f0f0);
    border-bottom: 1px solid var(--table-border-color);
    border-radius: 8px 8px 0 0;
  }
  
  /* Header Cell */
  .header-cell {
    font-weight: bold;
    background: var(--table-header-bg-color, #eaeaea);
    color: var(--text-color);
    flex: 1 1;
    padding: 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border-right: 1px solid var(--table-border-color);
  }
  
  .header-cell:last-child {
    border-right: none;
  }
  
  /* Table Row */
  .table-row {
    display: flex;
    border-bottom: 1px solid var(--table-border-color);
  }
  
  /* Table Cell */
  .table-cell {
    flex: 1 1;
    padding: 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    /* 👇 Removed the vertical line */
    /* border-right: 1px solid var(--table-border-color); */
  }
  
  
  /* Zebra Striping */
  .even {
    background: #ffffff;
  }
  
  .odd {
    background: #f9f9f9;
  }
  
  /* 🎯 DARK MODE STYLES */
  [data-theme='dark'] .virtual-table-wrapper {
    background-color: var(--table-background-color);
    border: 1px solid var(--table-border-color);
  }
  
  [data-theme='dark'] .table-header {
    background-color: #3a3a3a;
    color: white;
  }
  
  [data-theme='dark'] .header-cell {
    background-color: #3a3a3a;
    color: #ffffff;
  }
  
  [data-theme='dark'] .table-cell {
    background-color: #2e2e2e;
    color: #e0e0e0;
  }
  
  [data-theme='dark'] .even {
    background-color: #2a2a2a;
  }
  
  [data-theme='dark'] .odd {
    background-color: #1f1f1f;
  }
  

  .table-row:hover {
    background-color: var(--table-hover-bg, #f3f4f6); /* or any theme variable */
  }`, "",{"version":3,"sources":["webpack://./src/components/styles/VirtualizedTable.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAuDI;;GAED;IACC,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,2CAA2C;IAC3C,kBAAkB;IAClB,wCAAwC;IACxC,+CAA+C;EACjD;;EAEA,iBAAiB;EACjB;IACE,aAAa;IACb,cAAc;IACd,YAAY;IACZ,uDAAuD;IACvD,kDAAkD;IAClD,0BAA0B;EAC5B;;EAEA,gBAAgB;EAChB;IACE,iBAAiB;IACjB,iDAAiD;IACjD,wBAAwB;IACxB,SAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,iDAAiD;EACnD;;EAEA;IACE,kBAAkB;EACpB;;EAEA,cAAc;EACd;IACE,aAAa;IACb,kDAAkD;EACpD;;EAEA,eAAe;EACf;IACE,SAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;IACjC,uDAAuD;EACzD;;;EAGA,mBAAmB;EACnB;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,wBAAwB;EACxB;IACE,+CAA+C;IAC/C,2CAA2C;EAC7C;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA;IACE,gDAAgD,EAAE,0BAA0B;EAC9E","sourcesContent":["/* .virtual-table-wrapper {\r\n    border: 1px solid var(--table-border-color);\r\n    font-family: 'Inter', sans-serif;\r\n    font-size: 14px;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  .table-header {\r\n    display: flex;\r\n    background-color: var(--table-header-bg-color, #f0f0f0);\r\n    border-bottom: 1px solid var(--table-border-color);\r\n  }\r\n  \r\n  .virtual-table-wrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  .table-header {\r\n    flex-shrink: 0;\r\n    height: 40px;\r\n  }\r\n  \r\n  .table-row {\r\n    display: flex;\r\n    border-bottom: 1px solid var(--table-border-color);\r\n  }\r\n  \r\n  .table-cell {\r\n    flex: 1;\r\n    padding: 8px;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    border-right: 1px solid #eee;\r\n  }\r\n  \r\n  .table-cell:last-child {\r\n    border-right: none;\r\n  }\r\n  \r\n  .header-cell {\r\n    font-weight: bold;\r\n    background: var(--table-header-bg-color, #eaeaea);\r\n  }\r\n  \r\n  .even {\r\n    background: #ffffff;\r\n  }\r\n  \r\n  .odd {\r\n    background: #f9f9f9;\r\n  }\r\n   */\r\n\r\n   .virtual-table-wrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    overflow: hidden;\r\n    font-family: 'Inter', sans-serif;\r\n    font-size: 14px;\r\n    border: 1px solid var(--table-border-color);\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\r\n    background-color: var(--table-background-color);\r\n  }\r\n  \r\n  /* Table Header */\r\n  .table-header {\r\n    display: flex;\r\n    flex-shrink: 0;\r\n    height: 40px;\r\n    background-color: var(--table-header-bg-color, #f0f0f0);\r\n    border-bottom: 1px solid var(--table-border-color);\r\n    border-radius: 8px 8px 0 0;\r\n  }\r\n  \r\n  /* Header Cell */\r\n  .header-cell {\r\n    font-weight: bold;\r\n    background: var(--table-header-bg-color, #eaeaea);\r\n    color: var(--text-color);\r\n    flex: 1;\r\n    padding: 8px;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    border-right: 1px solid var(--table-border-color);\r\n  }\r\n  \r\n  .header-cell:last-child {\r\n    border-right: none;\r\n  }\r\n  \r\n  /* Table Row */\r\n  .table-row {\r\n    display: flex;\r\n    border-bottom: 1px solid var(--table-border-color);\r\n  }\r\n  \r\n  /* Table Cell */\r\n  .table-cell {\r\n    flex: 1;\r\n    padding: 8px;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    /* 👇 Removed the vertical line */\r\n    /* border-right: 1px solid var(--table-border-color); */\r\n  }\r\n  \r\n  \r\n  /* Zebra Striping */\r\n  .even {\r\n    background: #ffffff;\r\n  }\r\n  \r\n  .odd {\r\n    background: #f9f9f9;\r\n  }\r\n  \r\n  /* 🎯 DARK MODE STYLES */\r\n  [data-theme='dark'] .virtual-table-wrapper {\r\n    background-color: var(--table-background-color);\r\n    border: 1px solid var(--table-border-color);\r\n  }\r\n  \r\n  [data-theme='dark'] .table-header {\r\n    background-color: #3a3a3a;\r\n    color: white;\r\n  }\r\n  \r\n  [data-theme='dark'] .header-cell {\r\n    background-color: #3a3a3a;\r\n    color: #ffffff;\r\n  }\r\n  \r\n  [data-theme='dark'] .table-cell {\r\n    background-color: #2e2e2e;\r\n    color: #e0e0e0;\r\n  }\r\n  \r\n  [data-theme='dark'] .even {\r\n    background-color: #2a2a2a;\r\n  }\r\n  \r\n  [data-theme='dark'] .odd {\r\n    background-color: #1f1f1f;\r\n  }\r\n  \r\n\r\n  .table-row:hover {\r\n    background-color: var(--table-hover-bg, #f3f4f6); /* or any theme variable */\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
